import TFGConfig from './TFGConfig';

export default TFGConfig;
